import { ComponentProps, FC } from 'react'
import { CheckBoxIcon, CheckBoxIndicator, CheckBoxRoot } from './primitives'

export interface CheckboxProps {
  colorScheme?: 'indigo' | 'dark' | 'transparent'
}

export const Checkbox: FC<ComponentProps<typeof CheckBoxRoot> & CheckboxProps> = (props) => {
  return (
    <CheckBoxRoot {...props}>
      <CheckBoxIndicator>
        <CheckBoxIcon white={props.colorScheme !== 'dark'} />
      </CheckBoxIndicator>
    </CheckBoxRoot>
  )
}
